import { createFileRoute } from '@tanstack/react-router'
import { PageShell } from '@/features/public-site/page-shell'
import { SimpleHero, HeroBadges, PricingCta, Panel, Pill } from '@/features/public-site/sections'

export const Route = createFileRoute('/captions')({
  component: CaptionsPage,
})

function CaptionsPage() {
  return (
    <PageShell>
      <SimpleHero
        eyebrow="字幕与转写"
        title="动效字幕，"
        highlighted="50+ 样式"
        description="自动为视频添加精准的动效字幕。从 50+ 样式中自由选择，支持多语言转写。"
        buttonLabel="免费开始"
      />

      <HeroBadges
        items={[
          '50+ 字幕样式',
          '多语言',
          '词级时间轴',
          '自定义字体',
          '自动高亮',
        ]}
      />

      {/* Split section */}
      <section className="mx-auto mt-16 grid max-w-4xl gap-8 px-4 sm:px-6 lg:grid-cols-2">
        <Panel>
          <h2 className="text-xl font-bold text-foreground">
            抓住注意力的字幕
          </h2>
          <p className="mt-3 text-sm text-muted-foreground">
            从醒目的动态文字到优雅极简风格——为你的内容找到最合适的样子。
          </p>
          <div className="mt-6 flex flex-wrap gap-2">
            {[
              '醒目动态文字',
              '卡拉OK式高亮',
              '极简下三分之一',
              '弹出气泡',
              '故障特效',
              '手绘风格',
            ].map((style) => (
              <Pill key={style}>{style}</Pill>
            ))}
          </div>
        </Panel>

        {/* Preview card */}
        <div className="overflow-hidden rounded-2xl border border-border bg-card">
          <div className="flex aspect-video items-center justify-center bg-muted">
            <div className="rounded-lg bg-black/80 px-6 py-3 text-center">
              <span className="text-2xl font-black uppercase text-white">
                想想这个
              </span>
            </div>
          </div>
        </div>
      </section>

      <PricingCta />
    </PageShell>
  )
}
